"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductsListContextMenu = void 0;
const react_1 = __importDefault(require("react"));
const product_1 = require("../../../../../client/product");
const product_tree_nodes_1 = require("../../../../../client/product-tree-nodes");
const ui_components_1 = require("@groupby/ui-components");
const react_redux_1 = require("react-redux");
const launch_task_menu_item_component_1 = require("../partials/contextMenu/launch-task-menu-item.component");
const table_columns_1 = require("../../../../../common/table-columns");
const attributes_1 = require("../../../../../constants/attributes");
const query_params_1 = require("../../../../../hooks/query-params");
const use_strategy_matrix_query_params_sync_1 = require("../../../../../strategy-matrix/hooks/use-strategy-matrix-query-params-sync");
const utils_1 = require("../../../../../utils");
const icons_1 = require("../../../../../../icons");
const filter_icon_component_1 = require("../../../../../../icons/svg/filter-icon.component");
const new_tab_icon_component_1 = require("../../../../../../icons/svg/new-tab-icon.component");
const localization_1 = require("../../../../../../localization");
const router_constants_1 = require("../../../../../../router/router.constants");
const store_1 = require("../../../../../../store");
const pageUrlId = (0, table_columns_1.createColumnId)(attributes_1.PRODUCT_PAGE_URL_LABEL, { isAIEnriched: true });
const imageId = (0, table_columns_1.createColumnId)(attributes_1.PRODUCT_IMAGE_LABEL, { isAIEnriched: true });
const classificationTypeId = (0, table_columns_1.createColumnId)(attributes_1.CustomProductAttributes.ClassificationProductType, { isAIEnriched: true });
const checkboxId = ui_components_1.GRID_CHECKBOX_SELECTION_COL_DEF.field;
const useProductsListContextMenu = ({ onEdit, selectProduct, hasSelection = false, productTerminalNodeMap = {}, } = {}) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { getSearchParamsString } = (0, query_params_1.useSearchParamsString)();
    const selectedProjectId = (0, store_1.useSelectedProjectId)();
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const selectedProductTreeNodeId = (0, store_1.useSelectedTreeNodeId)();
    const expandedNodes = (0, store_1.useExpandedNodes)();
    const excludedItems = (0, store_1.useExpandedAttributes)();
    const { context, handleContextMenu: originalHandleContextMenu, handleClose, ContextMenu, } = (0, ui_components_1.useContextMenu)({
        closeOnItemClick: true,
        closeOnAwayClick: true,
    });
    const handleContextMenu = react_1.default.useCallback((event) => {
        const target = event.target;
        const cellElement = target === null || target === void 0 ? void 0 : target.closest('[role="gridcell"]');
        const cellId = (cellElement === null || cellElement === void 0 ? void 0 : cellElement.getAttribute('data-field')) || '';
        // Don't show context menu on URL, image, or checkbox cells
        if ([pageUrlId, imageId, checkboxId].includes(cellId))
            return;
        originalHandleContextMenu(event);
    }, [originalHandleContextMenu]);
    const { label, dataMeta } = (0, table_columns_1.parseColumnId)((context === null || context === void 0 ? void 0 : context.field) || '');
    const { getProductTerminalNode } = (0, product_1.useProductTerminalNodeHandler)();
    const navigateToMatrix = () => {
        var _a;
        const terminalNodeId = (context === null || context === void 0 ? void 0 : context.id)
            ? ((_a = productTerminalNodeMap[context.id]) !== null && _a !== void 0 ? _a : selectedProductTreeNodeId)
            : selectedProductTreeNodeId;
        const serializedSearchParams = (0, use_strategy_matrix_query_params_sync_1.getStrategyMatrixSearchParamsString)({
            projectId: selectedProjectId,
            catalogId: selectedCatalogId,
            viewState: {
                [use_strategy_matrix_query_params_sync_1.StrategyMatrixViewQueryStateField.TerminalNodeId]: terminalNodeId,
                [use_strategy_matrix_query_params_sync_1.StrategyMatrixViewQueryStateField.SelectedAttributes]: [label],
            },
        });
        window.open(`${router_constants_1.STRATEGY_MATRIX_PATH}${serializedSearchParams}`, '_blank');
    };
    const navigateToTask = () => {
        if (!(context === null || context === void 0 ? void 0 : context.id))
            return;
        const terminalNodeId = productTerminalNodeMap[context.id];
        if (!terminalNodeId)
            return;
        const serializedSearchParams = getSearchParamsString({
            projectId: selectedProjectId,
            catalogId: selectedCatalogId,
            terminalNodeId,
            attributeName: label,
            isMeasure: dataMeta.isMeasure || undefined,
        });
        window.open((0, router_constants_1.getEnrichAIPath)(router_constants_1.EnrichSection.HLQATaskView, serializedSearchParams), '_blank');
    };
    const handleFilterToNode = () => {
        if (context === null || context === void 0 ? void 0 : context.id) {
            void getProductTerminalNode(context === null || context === void 0 ? void 0 : context.id).then(({ fullPath }) => {
                if (fullPath) {
                    const newExpandedNodes = (0, product_tree_nodes_1.getExpandedNodesListByPath)(fullPath);
                    const expanded = new Set([...newExpandedNodes, ...(expandedNodes !== null && expandedNodes !== void 0 ? expandedNodes : [])]);
                    dispatch((0, store_1.enrichAISetSelectedTreeNodePath)(fullPath));
                    dispatch((0, store_1.enrichAISetExpandedNodes)(Array.from(expanded)));
                }
                dispatch((0, store_1.enrichAISetAttributesExcludedItems)((0, utils_1.updateUniqueItemListBasedOnValue)(label, true)(excludedItems)));
            });
        }
    };
    const isEnriched = (dataMeta.isMeasure || dataMeta.isAIEnriched) && ![
        pageUrlId,
        imageId,
        classificationTypeId,
    ].includes(context.field || '');
    const isLaunchTaskDisabled = !(context === null || context === void 0 ? void 0 : context.id) || !productTerminalNodeMap[context.id];
    const items = [
        {
            key: t({ key: 'FILTER_TO_NODE' }),
            content: react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(filter_icon_component_1.FilterIcon, null), " ", t({ key: 'FILTER_TO_NODE' })),
            onClick: handleFilterToNode,
        },
    ];
    if (isEnriched) {
        if (onEdit && !dataMeta.isMeasure) {
            items.push({
                key: t({ key: 'EDIT' }),
                content: react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(icons_1.EditIcon, { sx: { color: ui_components_1.baseColors.primaryBlueMed400 } }), " ", t({ key: 'EDIT' })),
                onClick: () => {
                    // Auto-select product if nothing is selected
                    if (!hasSelection && (context === null || context === void 0 ? void 0 : context.id) && selectProduct) {
                        selectProduct(context.id);
                    }
                    onEdit(label);
                },
            });
        }
        items.push({
            key: t({ key: 'SWITCH_TO_MATRIX' }),
            content: react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(new_tab_icon_component_1.NewTabIcon, null), " ", t({ key: 'SWITCH_TO_MATRIX' })),
            onClick: navigateToMatrix,
        }, {
            key: t({ key: 'LAUNCH_TASK' }),
            content: (react_1.default.createElement(launch_task_menu_item_component_1.LaunchTaskMenuItem, { label: t({ key: 'LAUNCH_TASK' }), isDisabled: isLaunchTaskDisabled })),
            onClick: !isLaunchTaskDisabled ? navigateToTask : undefined,
        });
    }
    return ({
        context,
        handleContextMenu,
        handleClose,
        ContextMenu: (props) => (react_1.default.createElement(ContextMenu, Object.assign({ items: items }, props))),
    });
};
exports.useProductsListContextMenu = useProductsListContextMenu;
